import { useAuthStore } from '@/stores/auth'
import client_lookup from '@/assets/json/clientLookups.json'

async function findSchema(navs, applicationName, schemaType) {
  const path = `../assets/json/nav/${applicationName}/${schemaType}.json`
  const result = Object.entries(navs).find(([modulePath, _]) => modulePath == path)

  if (!result) return null
  const [_, module] = result
  return await module()
}

export default async function () {
  const authStore = useAuthStore()

  if (!authStore.user) {
    await authStore.guestLogin()
  }

  const { application } = client_lookup
  const { resident, citizen, dubaiResident, TypingCenter } = application
  const { applicationId } = authStore.user

  let [applicationName] = Object.entries(application).find(([_, appId]) => appId == applicationId)

  if ([resident, citizen, dubaiResident].includes(applicationId)) {
    applicationName = 'individual'
  }

  if (applicationId == TypingCenter) {
    applicationName = 'typing_center'
  }

  const navs = import.meta.glob(`../assets/json/nav/*/*.json`)

  let navMenu = await findSchema(navs, applicationName, 'menu')
  let profileMenu = await findSchema(navs, applicationName, 'profile')

  return {
    nav: navMenu?.default || null,
    profile: profileMenu?.default || null
  }
}
